/**
 * @Author: 左建
 * @Date: 2022/7/7 14:30
 * @LastEditTime: 2022/7/7 14:30
 * @Description: 空白创建页面的一些静态属性
*/

// 工具栏
export const toolsList = Object.freeze([
    {
        text: "编辑",
        icon: "edit",
        val: "edit"
    },
    {
        text: "复制",
        icon: "copy-document",
        val: "copy"
    },
    {
        text: "删除",
        icon: "delete",
        val: "del"
    },
    {
        text: "上移",
        icon: "top",
        val: "moveUp"
    },
    {
        text: "下移",
        icon: "bottom",
        val: "moveDown"
    },
    {
        text: "置顶",
        icon: "upload2",
        val: "moveTop"
    },
    {
        text: "置底",
        icon: "download",
        val: "moveBottom"
    }
])
